import {
    fetchUserSuccessful,
    fetchUserFailure,
    logoutSuccessful,
    updatePreferredLanguageSuccessful,
    loginUserSuccessful, loginUserFailure,
    createUserSuccessful,
} from "../actions/login";
import { createReducer } from "redux-act";
const DEFAULT_USER = {
  userInfo: JSON.parse(localStorage.getItem('userInfo'))?.userInfo || null,
  isAuthenticated: JSON.parse(localStorage.getItem('userInfo'))?.isAuthenticated || false,
  loginUser: {
      status: false,
      error: false,
  }

};


export default createReducer(
  {
    [fetchUserSuccessful]: (state, payload) => {
      localStorage.setItem("userInfo", JSON.stringify({userInfo:payload ? payload: null,isAuthenticated: payload? true : false }));

      return {
        ...state,
        userInfo: payload ? payload : null,
        isAuthenticated: payload ? true : false,
      };
    },
    [fetchUserFailure]: (state, payload) => {
      return {
        ...state,
      };
    },
    [logoutSuccessful]: (state, payload) => {
      localStorage.clear();
     // window.location.href = '/login';
      return {
        ...state,
        userInfo: null,
        isAuthenticated: false,
      };
    },
    [updatePreferredLanguageSuccessful]: (state, payload) => {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))

      userInfo.userInfo.preferredLanguage = payload;
      localStorage.setItem("userInfo", JSON.stringify({...userInfo}));
      return{
        ...state,
        ...userInfo,
        preferredLanguage:payload
      }
    },

      [loginUserSuccessful]: (state, payload) => {
          return {
              ...state,
              loginUser:{
                  status:payload,
                  error: false
              },

          };
      },
      [loginUserFailure]: (state, payload) => {
          console.log("loginUserFailure",payload)
          return {
              ...state,
              loginUser:{
                  ...state.loginUser,
                  error:payload
              },
          };
      },

      [createUserSuccessful]: (state, payload) => {
          return {
              ...state,
          };
      },





  },
  DEFAULT_USER
);
